<template>
 
  
  <div class="page">

    <UiInput
      :label="$t('forgot_password_view_email')"
      :text="form.email.value"
      :name="'email'"
      :error="emailError"
      :locator="'forgot_password_view_email_locator'"
      @change:text="form.email.value = $event"
      @keyup.enter="login"
      @input="markInteracted('email')"
      @blur="markDirty('email')"
      />

    <NuxtTurnstile class="turnstile" ref="turnstile" v-model="token" />

    <div v-if="generalError" class="general-error-block">
      {{ generalError }}
    </div>

    
    <UiButtonGroup>
      <UiButton
        :name="$t('forgot_password_view_button_restore')"
        :type="'primary'"
        :locator="'forgot_password_view_button_restore_locator'"
        @click="login"
        :is-loading="isLoding"
        />        
      <UiButton
        :name="$t('universal_button_cancel')"
        :tag="'NuxtLink'"
        :type="'link'"
        to="/auth/signin"
        />          
    
    </UiButtonGroup>
 
    
  </div>  

</template>

<script setup lang="ts">
import { useFormValidation } from '~/composables/useFormValidation'
import { forgotPasswordFormConfig } from '~/types/validation/formsConfig'

definePageMeta({
  layout: "short",
  auth: false
})

const router = useRouter()
const { t } = useI18n();
const { $user, $api, $ga } = useNuxtApp()
const isLoding = ref(false)
const token = ref(null)
const turnstile = ref()
const generalError = ref('')

const form = reactive({
  email: {
    value: router.currentRoute?.value.query?.email?.toString() || '',
    isInteracted: false,
    isDirty: false
  }
})

const { validateField, markInteracted, markDirty, validateForm } = useFormValidation(form, forgotPasswordFormConfig)

const validation = {
  email: computed(() => validateField('email'))
}

const backendErrors = reactive({
  email: ''
})

const emailError = computed(() => backendErrors.email || validation.email.value.errorMessage)

const login = async () => {
  backendErrors.email = ''

  if (!validateForm()) {
    return false
  }

  isLoding.value = true
  try {
    await $api.postForgotPasswordRequest(form.email.value, token.value)
    form.email.value = ''
    isLoding.value = false
    useToast().success('Check your email for the password reset link')
    $ga.eventGA('user_forgot_password')
  } catch (error: any) {
    turnstile.value?.reset()
    isLoding.value = false

    switch (error.message) {
      case 'We could not find this Email':
        form.email.isDirty = true
        form.email.isInteracted = true
        backendErrors.email = t('forgot_password_view_error_email_dont_exist')
        break
      default:
        generalError.value = t('universal_generic_error')
    }
  }
}


</script>


<style scoped>
.page{
  padding: 2rem;
  max-width: 400px;
} 
.actions{
  /* margin-top: 10px; */
}
.actions > *{
  margin-right: 10px;
}
</style>
